var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"tippy",rawName:"v-tippy"}],attrs:{"title":"Resume recording"},on:{"click":_vm.resumeRecordingCLick}},[_c('font-awesome-icon',{attrs:{"icon":_vm.faDotCircle}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da221b4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rep-call/toolbar/recording-button/recording-resume-button.vue
// module id = RUSQ
// module chunks = 1